import { render, staticRenderFns } from "./submit-report.vue?vue&type=template&id=1be48e85&scoped=true&"
import script from "./submit-report.vue?vue&type=script&lang=js&"
export * from "./submit-report.vue?vue&type=script&lang=js&"
import style0 from "./submit-report.vue?vue&type=style&index=0&id=1be48e85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be48e85",
  null
  
)

export default component.exports